import {
	Component,
	EventEmitter,
	HostListener,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { DateUtils } from '../../utils/date-utils';

@Component({
	selector: 'app-week-selector',
	templateUrl: './week-selector.component.html',
	styleUrls: ['./week-selector.component.scss']
})
export class WeekSelectorComponent implements OnInit {
	//Les types primitifs sont passer par valeur entre les composants, on utilise donc un conteneur pour passer les données par références

	/**
	 * Numéro de semaine
	 */
	@Input() weekNumber: { value: number } = { value: null };

	/**
	 * Année
	 */
	@Input() yearNumber: { value: number } = { value: null };

	/**
	 * Période
	 */
	@Input() dateRange: { value: Date[] } = { value: null };

	/**
	 * Event emit lorsque la période change
	 */
	@Output() dateRangeChange: EventEmitter<any> = new EventEmitter();

	monthsFr = [
		'janv',
		'févr',
		'mars',
		'avr',
		'mai',
		'juin',
		'juill',
		'aout',
		'sept',
		'oct',
		'nov',
		'déc'
	];
	daysFr = [
		'Dimanche',
		'Lundi',
		'Mardi',
		'Mercredi',
		'Jeudi',
		'Vendredi',
		'Samedi'
	];

	/**
	 * Date du jour
	 */
	today: Date = new Date();

	constructor(private dateUtils: DateUtils, private facade: FacadeService) {}

	ngOnInit(): void {
		if (this.facade.dataStorageService.getParam('storedCalendarWeeknumber')) {
			this.weekNumber.value = this.facade.dataStorageService.getParam(
				'storedCalendarWeeknumber'
			) as number;
		}
		if (this.facade.dataStorageService.getParam('storedCalendarYearnumber')) {
			this.yearNumber.value = this.facade.dataStorageService.getParam(
				'storedCalendarYearnumber'
			) as number;
		} else {
			this.yearNumber.value = new Date().getFullYear();
		}
		this.today.setHours(0, 0, 0, 0);
		let searchedDate: Date;
		let secondSearchedDate: Date;
		if (
			this.weekNumber.value &&
			this.weekNumber.value >= 1 &&
			this.weekNumber.value <= 53
		) {
			searchedDate = this.dateUtils.getDateOfISOWeek(
				this.weekNumber.value,
				this.yearNumber.value
			);
		} else {
			searchedDate = this.dateUtils.getMonday(this.today);
			this.weekNumber.value = this.dateUtils.getWeekNumber(this.today);
		}

		if (this.facade.dataStorageService.getParam('missionStartDate')) {
			searchedDate = new Date(
				this.facade.dataStorageService.getParam('missionStartDate')
			);
		}

		secondSearchedDate = new Date(searchedDate);
		//Fin de semaine
		secondSearchedDate.setDate(searchedDate.getDate() + 6);

		if (this.facade.dataStorageService.getParam('missionEndDate')) {
			secondSearchedDate = new Date(
				this.facade.dataStorageService.getParam('missionEndDate')
			);
		}

		this.dateRange.value = [searchedDate, secondSearchedDate];
		this.dateRangeChange.emit();
	}

	/**
	 * Calcule des dates pour revenir à la semaine précédente
	 */
	previousWeek() {
		this.dateRange.value[0] = this.dateUtils.getMonday(this.dateRange.value[0]);
		this.dateRange.value[0].setDate(this.dateRange.value[0].getDate() - 7);
		this.dateRange.value[1] = new Date(this.dateRange.value[0]);
		this.dateRange.value[1].setDate(this.dateRange.value[1].getDate() + 6);
		this.updateYearAndWeekNumbers();
		this.cleanDateRangeSession();
	}

	/**
	 * Calcule des dates pour aller à la semaine suivante
	 */
	nextWeek() {
		this.dateRange.value[0] = this.dateUtils.getMonday(this.dateRange.value[0]);
		this.dateRange.value[0].setDate(this.dateRange.value[0].getDate() + 7);
		this.dateRange.value[1] = new Date(this.dateRange.value[0]);
		this.dateRange.value[1].setDate(this.dateRange.value[1].getDate() + 6);
		this.updateYearAndWeekNumbers();
		this.cleanDateRangeSession();
	}

	/**
	 * Calcule pour revenir à la semaine courante
	 */
	resetDateClick() {
		const date: Date = this.dateUtils.getMonday(new Date());
		date.setHours(0, 0, 0, 0);
		this.dateRange.value[0] = date;
		this.dateRange.value[1] = new Date(date);
		this.dateRange.value[1].setDate(date.getDate() + 6);
		this.updateYearAndWeekNumbers();
		this.cleanDateRangeSession();
	}

	/**
	 * Calcule du numéro de semaine et de l'année et stockage dans le localStorage
	 */
	updateYearAndWeekNumbers() {
		this.dateRange.value = [...this.dateRange.value];
		this.weekNumber.value = this.dateUtils.getWeekNumber(
			this.dateRange.value[0]
		);
		this.yearNumber.value = this.dateRange.value[0].getFullYear();
		this.facade.dataStorageService.setParam(
			'storedCalendarWeeknumber',
			this.weekNumber.value
		);
		this.facade.dataStorageService.setParam(
			'storedCalendarYearnumber',
			this.yearNumber.value
		);

		this.dateRangeChange.emit();
	}

	/**
	 * Supprime les dates du localStorage
	 */
	cleanDateRangeSession() {
		this.facade.dataStorageService.removeSessionItem('missionStartDate');
		this.facade.dataStorageService.removeSessionItem('missionEndDate');
	}

	/**
	 * Listener pour les frappes claviers
	 * @param event
	 */
	@HostListener('window:keyup', ['$event'])
	keyEvent(event: KeyboardEvent) {
		if (event.key === 'ArrowLeft') {
			this.previousWeek();
		}
		if (event.key === 'ArrowRight') {
			this.nextWeek();
		}
	}
}
